module.exports = __webpack_public_path__ + "static/media/fb icon.eeb1294c.svg";